'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconT, iconTTag } from '@ni/nimble-components/dist/esm/icons/t';
import { wrap } from '../../utilities/react-wrapper';

export type { IconT };
export { iconTTag };
export const NimbleIconT = wrap(IconT);